import React from "react";
import { createComponent, EventName } from "@lit/react";
import { BeamNonprofitSelectEvent } from "../../utils/events";
import { BeamSelectSubscriptionNonprofit as _BeamSelectSubscriptionNonprofit } from "./index";

export const BeamSelectSubscriptionNonprofit = createComponent({
  tagName: _BeamSelectSubscriptionNonprofit.tagName,
  elementClass: _BeamSelectSubscriptionNonprofit,
  react: React,
  events: {
    onNonprofitSelect: BeamNonprofitSelectEvent.eventName as EventName<BeamNonprofitSelectEvent>,
  },
});

export default BeamSelectSubscriptionNonprofit; // default alias for use with async import utils like next/dynamic and react.lazy
